import { LAYER_DEFS, GEWAS_COLORS, GEWAS_DEFAULT_COLOR } from '../config/layers.js';
import { toggleLayerVisibility } from '../map/layers.js';

function buildParcelsLegend() {
  const items = GEWAS_COLORS
    .filter((entry) => entry.label !== null)
    .map(
      (entry) => `
      <div class="layer-legend-row">
        <span class="layer-swatch" style="background:${entry.color};opacity:0.6"></span>
        <span class="layer-legend-label">${entry.label}</span>
      </div>`
    )
    .join('');

  const overigeRow = `
    <div class="layer-legend-row">
      <span class="layer-swatch" style="background:${GEWAS_DEFAULT_COLOR};opacity:0.6"></span>
      <span class="layer-legend-label">Overige</span>
    </div>`;

  return items + overigeRow;
}

export function initLayerControl(map, onWaterNeeded) {
  const container = document.getElementById('layer-control');

  const otherLayers = LAYER_DEFS.filter((l) => l.id !== 'parcels');
  const parcelsLayer = LAYER_DEFS.find((l) => l.id === 'parcels');

  container.innerHTML = `
    <h3>Kaartlagen</h3>
    ${otherLayers.map(
      (layer) => `
      <div class="layer-item">
        <input type="checkbox" id="toggle-${layer.id}" ${layer.visible ? 'checked' : ''} />
        <label for="toggle-${layer.id}">
          <span class="layer-swatch" style="background:${layer.color};opacity:${layer.fillOpacity + 0.3}"></span>
          ${layer.name}
        </label>
      </div>
    `
    ).join('')}
    <div class="layer-item">
      <input type="checkbox" id="toggle-parcels" ${parcelsLayer.visible ? 'checked' : ''} />
      <label for="toggle-parcels">${parcelsLayer.name}</label>
    </div>
    <div class="layer-legend" id="parcels-legend">
      ${buildParcelsLegend()}
    </div>
  `;

  for (const layer of otherLayers) {
    const checkbox = document.getElementById(`toggle-${layer.id}`);
    checkbox.addEventListener('change', async () => {
      // Water layer is lazy-loaded on first toggle
      if (checkbox.checked && layer.id === 'water' && onWaterNeeded) {
        await onWaterNeeded();
      }
      toggleLayerVisibility(map, layer.id, checkbox.checked);
    });
  }

  const parcelsCheckbox = document.getElementById('toggle-parcels');
  const parcelsLegend = document.getElementById('parcels-legend');
  parcelsCheckbox.addEventListener('change', () => {
    toggleLayerVisibility(map, 'parcels', parcelsCheckbox.checked);
    parcelsLegend.style.display = parcelsCheckbox.checked ? '' : 'none';
  });
}
